import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../public/editIcon/iconfont.css'

import {ElementTiptapPlugin} from 'element-tiptap';
import 'element-tiptap/lib/index.css';
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(ElementTiptapPlugin, {
  // lang: "zh",
  // spellcheck: false,
});
router.beforeEach((to, from, next) => {
  //console.log(to.meta.requireAuth)
  console.log(to)
  if(to.meta.isRequire){
    if(!window.localStorage.getItem("token")){
      next({
        path:'/login'
      })
    }
  }

  next()
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
